import Command from '@ckeditor/ckeditor5-core/src/command';

export default class CustomMovieSrcCommand extends Command {
    execute(options) {
        const model = this.editor.model;
        model.change(writer => {
            const selection = model.document.selection;
            const element = selection.getSelectedElement();


            if ( element.hasAttribute( 'url' ) ) {
                this.value = element.getAttribute( 'url' );
            } else {
                this.value = false;
            }
            writer.setAttribute('url', options, element);
            writer.setSelection( element, 'on' );
        });
    }

    refresh() {
        const model = this.editor.model;
        const selection = model.document.selection;
        const element = selection.getSelectedElement();

        this.isEnabled = !!element;

        if ( this.isEnabled && element.hasAttribute( 'url' ) ) {
            this.value = element.getAttribute( 'url' );
        } else {
            this.value = false;
        }
    }
}
